<template>
  <div class="c-dropdown">
    <div class="c-dropdown__toggler" @click="$emit('click')">
      <span>{{ toggler }}</span>
      <AppIcon v-if="!!iconName" :name="iconName" classes="c-icon--sm" />
    </div>
    <div class="c-dropdown__wrapper">
      <div class="c-dropdown__list">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import AppIcon from './AppIcon';

export default {
  name: 'AppDropdown',
  components: {
    AppIcon,
  },
  props: {
    toggler: {
      type: String,
      default: 'Open',
      required: false,
    },
    iconName: {
      type: String,
      required: false,
    },
  },
};
</script>

<style>
</style>
